import { CommonMessage } from '@frontend/lang';
import { LuCircleAlert, LuCircleCheck } from 'react-icons/lu';

import useBasicSignUpConfirmation from './basic-sign-up-confirmation.controller';

const BasicSignUpConfirmation = () => {
    const viewProps = useBasicSignUpConfirmation();

    return (
        <div
            className='flex flex-col items-center justify-center'
            style={{ height: '100vh' }}>
            <div className='flex h-1/4 flex-col justify-center p-3 align-middle'>
                <h1 className='text-brand-primary m-auto text-4xl font-black'>Confirming sign-up</h1>
                <div className='flex w-full flex-col content-center items-center'>
                    <div className='m-auto'>
                        {viewProps.response ? (
                            <ConfirmationComponent
                                submitted={viewProps.submitted}
                                response={viewProps.response}
                            />
                        ) : (
                            <button
                                className='bg-brand-primary inline-flex w-1/3 cursor-pointer items-center justify-center rounded-md px-4 py-3'
                                id='confirm-button'
                                onClick={viewProps.onSubmit}
                                data-testid='confirmButton'>
                                <div className='text-always-white justify-start text-base font-medium'>{CommonMessage.BUTTONS.CONFIRM}</div>
                            </button>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BasicSignUpConfirmation;

export const ConfirmationComponent = (props: { submitted: boolean; response: any }) => {
    if (props.submitted && !props.response) {
        return <div className='spinner-border'></div>;
    } else if (props.response && props.response.type === 'error') {
        return (
            <>
                <LuCircleAlert
                    size={30}
                    className='text-status-danger mb-2'
                />
                <strong>{props.response.message}</strong>
            </>
        );
    } else if (props.response && props.response.type === 'success') {
        return (
            <>
                <LuCircleCheck
                    size={30}
                    className='text-status-success mb-2'
                />
                <strong>{props.response.message}</strong>
            </>
        );
    } else {
        return null;
    }
};
